import { render, staticRenderFns } from "./UserGroupSelectionOptionsDropdown.vue?vue&type=template&id=6b025686"
import script from "./UserGroupSelectionOptionsDropdown.vue?vue&type=script&lang=js"
export * from "./UserGroupSelectionOptionsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports